export const ADD_PRODUCT = 'ADD_PRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const REMOVE_ALL_PRODUCTS = 'REMOVE_ALL_PRODUCTS';
export const SET_QUANTITY = 'SET_QUANTITY';

export const addProduct = (id, name, price, image, virtual, variationId, selections) => ({
  type: ADD_PRODUCT,
  id,
  name,
  price,
  image,
  virtual,
  variationId,
  selections,
});

export const removeProduct = (id, variationId) => ({
  type: REMOVE_PRODUCT,
  id,
  variationId,
});

export const removeAllProductsFromCart = () => ({
  type: REMOVE_ALL_PRODUCTS,
});

export const setQuantity = (id, variationId, quantity) => ({
  type: SET_QUANTITY,
  id,
  variationId,
  quantity,
});
